import { Product } from '@virginexperiencedays/products';
import config from '../../../SEO/structured_data.config.json';

const itemPage = ({
  title,
  slug,
  media: { mainImage: { url: imageUrl } } = {
    mainImage: { url: null, altText: null, caption: null },
    images: [],
    video: { videoId: null },
  },
  pagePathOverride,
  hideFaqs = false,
}: Product & { pagePathOverride?: string; hideFaqs?: boolean }) => {
  const { website } = config;
  const pagePath = pagePathOverride || `/product/${slug}`;
  const pageUrl = `${website.url?.replace(/\/$/, '')}${pagePath}`;

  return {
    '@type': 'ItemPage',
    '@id': `${pageUrl}#webpage`,
    url: pageUrl,
    name: title,
    inLanguage: website.inLanguage,
    isPartOf: {
      '@id': website['@id'],
    },
    primaryImageOfPage: {
      '@id': imageUrl,
    },
    breadcrumb: {
      '@id': `${pageUrl}#breadcrumb`,
    },
    ...(!hideFaqs && {
      hasPart: {
        '@id': `${pageUrl}#faqs`,
      },
    }),
  };
};

export default itemPage;
